import { createComponent } from '@/helpers/alpine';
import prestashop from 'prestashop';

const EmailCheck = createComponent(() => ({
    step: 'email',
    email: '',
    error: '',

    setEmail(email: string) {
        this.email = email;
    },

    async checkEmail() {
        this.error = '';
        const formData = new FormData();
        const action = prestashop.urls.pages.authentication;
        formData.append('email', this.email);
        formData.append('ajax', 'true');
        formData.append('action', 'checkMail');

        const res = await fetch(action, {
            method: 'POST',
            body: formData,
            headers: {
                Accept: 'application/json',
            },
        });
        const data = await res.json();

        if (data.exists) {
            this.step = 'login';
            this.error = '';
        } else if (data.valid) {
            this.step = 'register';
            this.error = '';
        } else {
            this.error = 'Adresse e-mail invalide.';
        }
    },
}));

export { EmailCheck };
